/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Încărcare...',
	'dlg_close': 'Închidere',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Anulare',
	'dlg_back': 'Deplasare înapoi',

	// Slider
	'sliderRegionLabel': 'Control glisor, utilizaţi săgeţile stânga şi dreapta pentru a muta handle-urile glisorului',
	'sliderHandleLabel': 'Handle glisor',
	'a11ySliderHandleLabel': 'Handle glisor %{sliderValue}',
	'sliderInputLabel': 'valoare',

	// Side bar
	'sidebarAdd': 'Adăugare',
	'clearTextFilterValue': 'Curăţare',
	'missingDataSetData': 'Datele pentru acest set de date nu sunt disponibile. Reîmprospătaţi setul de date sau contactaţi-vă administratorul pentru accesul la sursă.',

	// Toolbar
	'toolbarRegionLabel': 'Bară de unelte',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Familie de fonturi',
	'fontSizeSelect': 'Mărime font',
	'bold': 'Aldin',
	'italic': 'Cursiv',
	'underline': 'Subliniere',
	'justifyLeft': 'Aliniere la stânga',
	'justifyCenter': 'Aliniere la centru',
	'justifyRight': 'Aliniere la dreapta',
	'insertOrderedList': 'Listă ordonată',
	'insertUnorderedList': 'Listă neordonată',
	'fontColorPicker': 'Selector de culoare',
	'textWrap': 'Încadrare text',
	'restore': 'Restaurare valori implicite',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Număr de rezultate',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'Valoarea poate fi  %{lower} - %{higher}',
	'topbottomSelectOption': 'Opţiune Vârf sau sfârşit:',
	'topbottomOptionLabel': 'Afişare',
	'searchByLabel': 'De',
	'searchNoMatches': 'Nu s-a găsit nicio potrivire',
	'topbottomRankColumnLabel': 'Adăugare în tabel coloană de rang',
	'topbottomNone': 'Fără',
	'topCount': 'Număr primele',
	'topPercent': 'Primele %',
	'bottomCount': 'Număr ultimele',
	'bottomPercent': 'Ultimele %',
	'searchColumn': 'Găsirea unei coloane',
	'searchColumnAriaLabel': 'Găsiţi o coloană. Tastaţi numele coloanei de căutat, apoi utilizaţi săgeata în jos pentru a găsi coloana într-o listă',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Curăţare',

	// Format
	'formatAuto': 'Auto',
	'formatConvertPercent': 'Convertire zecimale la procentaj',
	'formatAbbreviate': 'Abreviere',
	'formatUseGrouping': 'Utilizare separator de mii',
	'dateStyle': 'Stil de dată',
	'dateTimeStyle': 'Stil dată-oră',
	'formatMissingValueCharactersInfo': 'Caracterele pentru valoarea lipsă specifică caracterele de afişat când valoarea lipseşte.',
	'currencySymbolLabel': 'Simbol monetar',
	'customSymbolPlaceholder': 'Adăugare simbol',
	'customSymbolLabelInfo': 'Specificaţi un caracter sau mai multe caractere de utilizat ca un simbol personalizat. Simbolul va precede numărul şi orice semn. ',
	'numberLabel': 'Etichetă număr',
	'numberPositionLabel': 'Poziţie etichetă',
	'numberLabelInfo': 'Specifică o etichetă pentru numărul formatat şi plasată ca un prefix sau sufix în funcţie de poziţia etichetei. ',
	'nullValueDefault': '<implicit>',
	'nullValueContent': '(nicio valoare)',
	'default': 'Implicit',
	'beginning': 'Început',
	'end': 'Sfârşit',

	// More data indicator
	'moreDataIndicator': 'Datele dumneavoastră au fost decupate la %{threshold} din articole. Aplicaţi un filtru pentru a afişa mai puţin',

	// Expanded View / Focus mode
	'evCollapse': 'Restrângere',
	'duplicate': 'Duplicare',
	'copyOf': 'Copiere %{name}',
	'unableToDuplicateBoard': 'Imposibil de duplicat "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Nu putem încărca obiectele.',

	// Custom widgets
	'customWidget': 'Widget personalizat'
});
